import React from 'react'
import { Link } from 'gatsby'

const isExternalUrl = (urlString: string) => {
  try {
    return Boolean(new URL(urlString))
  } catch (e) {
    return false
  }
}

/**
 * Util Component that will render the proper Link Component depending
 * whether the url is relative or absolute
 *
 * @return React Component
 */
export const HandleExternalLink = ({ to: url, ...props }: any) => {
  const isExternal = isExternalUrl(url)
  // eslint-disable-next-line react/jsx-no-target-blank
  return isExternal ? (
    <a href={url} target="_blank" rel="noreferrer" {...props} />
  ) : (
    <a href={url} {...props} />
  )
}
